export default "__VITE_ASSET__BgIyqVjb__"